export const ADJUSTED_LOGGED_TIME_MIN = 0;
export const ADJUSTED_LOGGED_TIME_MAX = 3600 * 24;
